import { render, staticRenderFns } from "./ToastNotification.vue?vue&type=template&id=70d55e99"
import script from "./ToastNotification.vue?vue&type=script&lang=js"
export * from "./ToastNotification.vue?vue&type=script&lang=js"
import style0 from "./ToastNotification.vue?vue&type=style&index=0&id=70d55e99&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports